import { render, staticRenderFns } from "./HisIcon.vue?vue&type=template&id=70d09f64&scoped=true"
import script from "./HisIcon.vue?vue&type=script&lang=js"
export * from "./HisIcon.vue?vue&type=script&lang=js"
import style0 from "./HisIcon.vue?vue&type=style&index=0&id=70d09f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d09f64",
  null
  
)

export default component.exports